<div class="rts-about-area rts-section-gap bg-about-sm-shape">
    <div class="container">

        <div class="row mb-5">
            <div class="col-12">
                <div class="title-area-client text-center">
                    <p class="client-title">{{ "MENU.ABOUT US" | translate }}</p>
                </div>
            </div>
        </div>

        <div class="row g-5 align-items-center">






            <!-- about left -->
            <div class="col-lg-5 col-md-12 col-sm-12 col-12 mt_md--50 mt_sm--50">
                @for (item of (aboutUs() |slice:0:1); track $index) {
                <div class="rts-title-area">
                    <h2 class="title title-red">
                        {{item?.titleAr}}
                    </h2>
                    <!-- <div class="pre-title pre-title-gray" [innerHTML]="item?.descriptionAr"> </div>-->
                    <p class="pre-title pre-title-gray">{{item?.summaryAr}}</p>

                </div>
                }
                <div class="about-inner">

                    <!-- start about success area -->
                    <!-- <div class="row about-success-wrapper">
                         left wrapper start 
                        <div class="col-lg-12 col-md-12">
                            @for (about of (aboutUs() | slice:0:1); track $index) {
                            @for (item of about?.aboutUsFeacturers; track $index) {
                            <div class="single">
                                <i class="far fa-check"></i>
                                <p class="details">
                                    {{item?.featurNameAr}}
                                </p>
                            </div>
                            }
                            }
                        </div>  -->
                    <!-- left wrapper end -->
                    <!-- </div> -->
                    <!-- start about success area -->

                    @if(settings()[0]?.unifiedNumber){
                    <!-- about founder & get in touch start -->
                    <div class="row about-founder-wrapper align-items-center mt--40">
                        <!-- right founder area -->
                        <div class="col-lg-6 col-md-6 col-sm-6 col-12 mt_sm--20">
                            <div class="author-call-option">
                                <!-- <img class="authore-call" src="./images/about/call.svg" alt="call_founder"> -->
                                <div class="">
                                    <!-- <span>{{"ABOUT.CALLME" | translate }}</span>
                                    @for (item of (settings() | slice:0:1); track $index) {
                                    <a [href]="'tel:'+ item?.unifiedNumber">
                                        <h6 class="title">{{item?.unifiedNumber}}</h6>
                                    </a>
                                    } -->

                                    <a [routerLink]="'/profile/memberships'" class="rts-btn btn-primary color-h-black">
                                        {{"ABOUT.BECOME_A_MEMBER" | translate}}
                                        <!-- <span>{{"ABOUT.BECOME_A_MEMBER" | translate}} </span>
                                        <i class="bi bi-arrow-right fw-bold mt-1"></i> -->
                                    </a>
                                </div>
                            </div>
                        </div>
                        <!-- left founder area -->
                    </div>
                    <!-- about founder & get in touch end -->
                    }
                </div>
            </div>
            <!-- about right -->

            <!-- about-right Start-->
            <div class="col-lg-5 col-md-12 col-sm-12 col-12 ">
                @for (item of (aboutUs() | slice:0:1); track $index) {
                <div class="about-one-thumbnail">
                    <img *ngIf="item?.image?.path" [src]="item.image.path | imageUrl" [alt]="item?.image?.originalName">
                    <div class="experience">
                        <div class="left single">
                            <h2 class="title">75+</h2>
                            <p class="time">{{ "ABOUT.YEARS" | translate }}</p>
                        </div>
                        <div class="right single">
                            <p class="disc">
                                {{ "ABOUT.HISTORY" | translate }} 1954
                            </p>
                        </div>
                    </div>
                </div>
                }
            </div>
            <!-- about-right end -->

            <div class="col-lg-2 aboutus-home-ad-space">

                @for (item of Announcements(); track $index) {
                @if (!item.isDefault) {
                <a target="_blank" [href]="item?.url" class="col-md-4 home-ad-space">
                    <app-ads [imageSrc]="item?.image?.path | imageUrl" [altText]="item?.name" [showSpacing]=false
                        ngClass="v-ad-space">
                    </app-ads>
                </a>
                }
                @else {
                <app-ads imageSrc="/images/ad/350.350.png" [showSpacing]=false ngClass="v-ad-space"></app-ads>
                }
                }
            </div>


        </div>
    </div>
</div>